import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ContainerComponent } from '../../../shared/components/container/container.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';

@Component({
  selector: '[section1]',
  imports: [NgTemplateOutlet, ContainerComponent, PictureComponent],
  templateUrl: './section1.component.html',
  styleUrl: './section1.component.scss',
  host: {
    id: 'understand-risk-factors',
  },
})
export class Section1Component {}
